import { useApi } from '@omnipresentgroup/api';
import type { CreateEmployeeContractResponse } from '@omnipresentgroup/types';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';

import { API_BASE, API_PATH } from '../constants';

export const useCreateEmployeeContractMutation = ({
  employeeId,
  onSuccess,
}: Omit<UseMutationOptions, 'mutationFn'> & { employeeId: string }) => {
  const { POST } = useApi();

  return useMutation({
    mutationFn: () => {
      return POST<CreateEmployeeContractResponse>({
        path: `${API_BASE}/${API_PATH}/${employeeId}/contracts`,
      });
    },
    onSuccess,
  });
};
